import React from "react";
import { ShelterBedMetric } from "./ShelterBedMetric";

export const ShelterCommittedPercentageMetric = ({ data }: any) => (
  <ShelterBedMetric
    data={data}
    title="Committed %"
    subtitle="occupied + reserved"
    tooltip="Beds that cannot be offered to anyone, as a share of all beds. The number that answers whether you can take another case tonight."
    field="committed_rate"
    asPercent
  />
);
